import React, { useEffect } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

interface TopLimitDropdownProps {
  title: string;
  onSelect: (value: number, label: string) => void;
  size?: "sm" | "lg";
  variant?: string;
  stopPropagation?: boolean;
  show?: boolean; // controlled show
  onToggle?: (isOpen: boolean) => void; // controlled toggle
}

const options = [
  { value: 5, label: "Top 5" },
  { value: 10, label: "Top 10" },
  { value: 15, label: "Top 15" },
  { value: 20, label: "Top 20" },
];

const TopLimitDropdown: React.FC<TopLimitDropdownProps> = ({
  title,
  onSelect,
  size = "sm",
  variant = "outline-secondary",
  stopPropagation = false,
  show,
  onToggle,
}) => {
  useEffect(() => {
    const handleScroll = () => {
      if (show) {
        onToggle?.(false);
      }
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [show, onToggle]);
  return (
    <DropdownButton
      size={size}
      variant={variant}
      title={
        <span className="d-flex align-items-center">
          {title}{" "}
          <span className="material-symbols-outlined pageinfo">page_info</span>
        </span>
      }
      className="rounded-pill"
      show={show} // controlled
      onToggle={onToggle} // controlled
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
    >
      {options.map((option) => (
        <Dropdown.Item
          key={option.value}
          onClick={() => onSelect(option.value, option.label)}
        >
          {option.label}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default TopLimitDropdown;
